export default __webpack_public_path__ + "static/media/1MM-Gold-plated-bangles.797a4aa3.jpg";